import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tier-guide',
  templateUrl: './tier-guide.component.html',
  styleUrls: ['./tier-guide.component.css']
})
export class TierGuideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
